import { render, staticRenderFns } from "./change-phone.vue?vue&type=template&id=7c11e452&scoped=true&"
import script from "./change-phone.vue?vue&type=script&lang=js&"
export * from "./change-phone.vue?vue&type=script&lang=js&"
import style0 from "./change-phone.vue?vue&type=style&index=0&id=7c11e452&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c11e452",
  null
  
)

export default component.exports